import dayjs from "dayjs"

// `dayjs.tz()` is "now" in the account's timezone (DayjsProvider sets it as the
// default), the zone the backend reads "this month" in — not the browser's.

/** "Sep 2026" for a `YYYY-MM-DD` month start. Parsed as a calendar date, never
 *  as a UTC instant, which would read as the previous month west of Greenwich. */
export const monthLabel = (value: string, locale?: string): string =>
  new Date(`${value.slice(0, 7)}-01T00:00:00`).toLocaleDateString(locale, {
    month: "short",
    year: "numeric"
  })

export const currentMonthStart = (): string =>
  dayjs.tz().startOf("month").format("YYYY-MM-DD")

/** The months a budget can be scheduled from beyond next month: the eleven
 *  after it, e.g. Nov 2026 – Sep 2027 in September 2026. */
export const selectableLaterMonths = (): string[] =>
  Array.from({ length: 11 }, (_, index) =>
    dayjs()
      .startOf("month")
      .add(index + 2, "month")
      .format("YYYY-MM-DD")
  )

export const nextMonthStart = (): string =>
  dayjs.tz().startOf("month").add(1, "month").format("YYYY-MM-DD")
